// extracted by mini-css-extract-plugin
module.exports = {"container__list":"List_container__list__BlM85"};